import { themeGet } from '@styled-system/theme-get';
import { getPaletteColor } from 'pcln-design-system';
import { ChevronLeft, ChevronRight } from 'pcln-icons';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import { getNextMonthLabel, getPrevMonthLabel } from '../utils/ariaLabelGenerators';
const LeftArrow = /*#__PURE__*/styled.button.withConfig({
  displayName: "Arrow__LeftArrow",
  componentId: "sc-elqfo7-0"
})(["display:none;", "{", "}background-color:", ";padding-left:24px;padding-right:0;margin:0;margin-top:24px;position:absolute;top:0;left:0;border:0;border-radius:", ";cursor:", ";"], props => props.theme.mediaQueries[1], props => !props.isMobile && `
      display: block;
    `, getPaletteColor('background.lightest'), themeGet('borderRadii.md'), props => props.disabled ? 'not-allowed' : 'pointer');
const RightArrow = /*#__PURE__*/styled(LeftArrow).withConfig({
  displayName: "Arrow__RightArrow",
  componentId: "sc-elqfo7-1"
})(["display:none;", "{", "}left:auto;right:0;padding-left:0;padding-right:24px;"], props => props.theme.mediaQueries[1], props => !props.isMobile && `
      display: block;
    `);
function Arrow({
  isDisabled,
  isMobile,
  isPrev,
  monthCount = 0,
  monthsToShow = 1,
  use2024DesignSeti,
  ...props
}) {
  const ariaLabel = useMemo(() => {
    const label = isPrev ? getPrevMonthLabel(monthCount) : getNextMonthLabel(monthCount, monthsToShow);
    return `Show ${label}${isDisabled ? ' Disabled' : ''}`;
  }, [isPrev, monthCount, monthsToShow]);
  const color = isDisabled ? 'background.tint' : use2024DesignSeti ? 'primary.base' : 'text.base';
  return isPrev ? React.createElement(LeftArrow, {
    "aria-label": ariaLabel,
    disabled: isDisabled,
    isMobile: isMobile,
    ...props
  }, React.createElement(ChevronLeft, {
    color: color
  })) : React.createElement(RightArrow, {
    "aria-label": ariaLabel,
    disabled: isDisabled,
    isMobile: isMobile,
    ...props
  }, React.createElement(ChevronRight, {
    color: color
  }));
}
export default memo(Arrow);